<mat-card>
  <mat-card-content style="margin: 20px 0px">
    <div style="padding-bottom: 30px" fxLayout="column" fxLayoutAlign="center start">
      <p style="font-size: 16px">{{ title }}</p>
    </div>
    <div fxLayoutGap="20px" fxLayout="row" fxLayoutAlign="end center">
      <button mat-stroked-button style="width: fit-content; border: none" (click)="onNo()">
        No
      </button>
      <button mat-stroked-button style="width: fit-content; border: none" (click)="onYes()">
        Yes
      </button>
    </div>
  </mat-card-content>
</mat-card>
